import axios from 'axios'
import qs from 'qs'
import apiConfig from 'api-config'
import Cookies from 'js-cookie'
import Vue from 'vue'

const backAPi = apiConfig.api
axios.interceptors.request.use(config => {
  return config
}, error => Promise.resolve(error.response || error))

axios.interceptors.response.use(response => response, error => {
  if (error.response.status === 401) {
    window.location.href = '../index.html'
  }else {
    Vue.prototype.$message.error(error.response.data.message)
    // Promise.resolve(error.response || error)
  }
})

export default {
  buildConfig (contentType, method, url) {
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': contentType,
      'X-PDD-Pati':  Cookies.get("pati"),
      'X-PDD-PageCode':  Cookies.get("X-PDD-PageCode"),
      'X-Nideshop-Token': Cookies.get('token'),
      'Authorization': 'Bearer ' + Cookies.get('token')
    }
    const baseConfig = {
      headers,
      timeout: 30000,
      withCredentials: true
    }
    const config = {
      ...baseConfig,
      method,
      url: apiConfig.api  + url
    }
    return config;
  },
  handleData(responseData){
    if (responseData==undefined){
      throw new Error("接口异常")
    }
    return responseData.data.data
  },
  async RESTful (url, data) {
    let  config=this.buildConfig('application/x-www-form-urlencoded; charset=UTF-8','get',url)
    config.params = data
    const responseData = await axios(config)
    return this.handleData(responseData)
  },
  async RESTFULJson (url, data) {
    let  config=this.buildConfig('application/json; charset=UTF-8','post',url)
    config.data = data
    const responseData = await axios(config)
    return this.handleData(responseData)
  },
  FormDataUp (url, file) {
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Bearer ' + Cookies.get('token')
    }
    const config = {
      headers,
      timeout: 30000,
      withCredentials: true
    }
    const Fromurl = apiConfig.api  + url
    return Vue.http.post(Fromurl, file, config)
  },
  FormDataDown (url, file) {
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Authorization': 'Bearer ' + Cookies.get('token')
    }
    const config = {
      headers,
      timeout: 30000,
      withCredentials: true
    }
    const Fromurl = apiConfig.api  + url
    return Vue.http.post(Fromurl, file, config)
  },

  async downLoad(url, data) {
    let  config=this.buildConfig('application/x-www-form-urlencoded; charset=UTF-8','get',url)
    config.params = data
    config.responseType= 'blob'
    const api = apiConfig.api  + url
    console.log(config)

    axios.get(api, config)
      .then(response => {
        let fileName= response.headers['content-disposition'].split(";")[1].split("=")[1];
        fileName = decodeURIComponent(fileName);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => {
        console.error(error);
      });
  },

  backAPi
}



// WEBPACK FOOTER //
// ./src/api/index.js